// Story 10.5 — Bloqueo de vistas de desarrollo en mobile.

import { Link } from '@tanstack/react-router';
import { ArrowLeft, Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useIsDesktop } from '@/hooks/use-is-desktop';

interface Props {
  /** Min width en px que se considera "desktop". Default 1024. */
  minWidth?: number;
  /** Render normal cuando estamos en desktop. */
  children: React.ReactNode;
}

export function DesktopOnlyNotice({ minWidth = 1024, children }: Props): React.ReactElement {
  const isDesktop = useIsDesktop(minWidth);
  if (isDesktop) return <>{children}</>;
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="items-center text-center">
          <div className="rounded-full bg-primary/10 p-4">
            <Monitor className="h-8 w-8 text-primary" aria-hidden />
          </div>
          <CardTitle>Vista optimizada para escritorio</CardTitle>
          <CardDescription>
            Esta vista está optimizada para escritorio. Por favor abre el dashboard en una pantalla
            más grande.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button asChild variant="default">
            <Link to="/">
              <ArrowLeft className="h-4 w-4" /> Volver al dashboard
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
